/*
 *
 * ProcessingRulesPopup
 *
 * @version 1.0.0
 * @author Alessandro Mosca
 * @since 23-Jan-2025
 */

import ProcessingRulesPopup from './ProcessingRulesPopupContainer'

export default ProcessingRulesPopup
